import ApiKeysResource from './api-keys-resource';

const ACCOUNT_URL = '/account';

export default function AccountResources({ base }) {
  return {
    ApiKeys: ApiKeysResource({ base, accountUrl: ACCOUNT_URL }),
  };
}
